import React from 'react'

const CabinLuggage = () => {
    return (
        <svg width="13" height="17" viewBox="0 0 13 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.3363 2.42894C8.3363 1.52785 7.60581 0.797363 6.70472 0.797363C5.80362 0.797363 5.07314 1.52785 5.07314 2.42894M11.5995 14.6658C12.05 14.6658 12.4152 14.3005 12.4152 13.85V10.5868C12.4152 10.1363 12.05 9.77105 11.5995 9.77105M1.84821 9.7712C1.39742 9.76767 1.02912 10.13 1.02559 10.5806L1.00003 13.8436C0.996495 14.2942 1.35907 14.6623 1.80985 14.6658M9.96788 16.2974V13.85C9.96788 12.0478 8.50691 10.5868 6.70472 10.5868C4.90253 10.5868 3.44156 12.0478 3.44156 13.85V16.2974H9.96788ZM6.70472 2.42894C9.40801 2.42894 11.5995 4.62039 11.5995 7.32368V15.4816C11.5995 15.9321 11.2342 16.2974 10.7837 16.2974H2.62577C2.17523 16.2974 1.80998 15.9321 1.80998 15.4816V7.32368C1.80998 4.62039 4.00143 2.42894 6.70472 2.42894ZM5.48742 7.32368H7.93479C8.38534 7.32368 8.75058 6.95844 8.75058 6.50789C8.75058 6.05734 8.38534 5.6921 7.93479 5.6921H5.48742C5.03687 5.6921 4.67163 6.05734 4.67163 6.50789C4.67163 6.95844 5.03687 7.32368 5.48742 7.32368Z"
                stroke="#1A1A1A"
                stroke-width="0.7"
            />
        </svg>
    )
}

export default CabinLuggage
